import type { DocumentDTO } from '@/services/documents';

/** Status amigável para UI — sem strings cruas do provider. */
export function documentStatusLabel(doc: Pick<DocumentDTO, 'provider' | 'externalStatus'>): string | null {
  if (doc.provider !== 'MEMED') return null;
  switch (doc.externalStatus) {
    case 'SIGNED':
      return 'Assinada';
    case 'PENDING':
      return 'Pendente';
    case 'CANCELLED':
      return 'Cancelada';
    case 'FAILED':
      return 'Indisponível';
    case 'ISSUED':
    case 'UNKNOWN':
    case null:
    case undefined:
    default:
      return 'Emitida';
  }
}
